<template lang="pug">
  .sharepoint-modal
    b-modal(
      id="sharepointmodal",
      :title="title",
      size="xl",
      ok-variant="primary",
      ref="sharepointmodal",
      ok-title="Ok",
      cancel-title="Abbrechen",
      @ok="importFiles"
    ).modal-fullscreen2
      b-row
        b-col(cols="8")
          .file-browser(style="height: 500px; overflow-y: auto;")
            .mb-3
              // Breadcrumb Navigation
              b-breadcrumb
                b-breadcrumb-item(
                  v-for="(crumb, index) in breadcrumbs",
                  :key="index",
                  :active="index === breadcrumbs.length - 1",
                  @click="navigateTo(index)"
                ) {{ crumb || 'Sharepoint / ' }}
            .small.mb-2 Wähle einen Ordner zum Importieren aus
            // Subdirectories List
            template(v-if="directories.length")
              h5 Subverzeichnisse
              b-list-group(class="mb-3", size="sm")
                b-list-group-item(
                  v-for="dir in directories",
                  :key="dir",
                  action,
                 
                  @click="navigateInto(dir)"
                ).breadcrumb.p-1.small {{ dir }}
            // Files List
            template(v-if="files.length")
              hr
              b-form-checkbox(
                v-model="selectAllFiles",
                @change="toggleSelectAllFiles",
                class="mt-3"
              ) Alle Dateien/Ordner auswählen 
            

              b-form-checkbox-group(
                v-model="selectedFiles",
                class="block mt-4",
                :disabled="selectAllFiles"
              )
                b-form-checkbox(
                  v-for="file in files",
                  class="block",
                  :key="file.name",
                  :value="file.path + (file.folder ? '/' : '')"
                ) 
                  span(v-if="!file.folder" class="file-name")
                    | {{ file.name }}
                    span.text-muted.ml-1 ({{ formatFileSize(file.size) }})
                  span(v-if="file.folder" class="folder-name" @click.stop="navigateInto(file.name)") Ordner: {{ file.name }}

            template(v-else)
              .text-center
                .small Keine Dateien in diesem Verzeichnis.
        b-col(cols="4")
          .small Konfiguration 
          b-form-checkbox(v-model="split") Dateien sollen gesplittet werden.
          .mt-4
            .small PDF-Komprimierung (Import-Override)
            select.form-control.form-control-sm(v-model="compressionStrategy")
              option(value="none") Keine Komprimierung
              option(value="normal") Alle Dateien komprimieren (normal)
              option(value="strong") Alle Dateien komprimieren (stark)
            .mt-2(v-if="compressionStrategy !== 'none'")
              b-form-checkbox(v-model="compressionOnlyLargeFiles") Nur Dateien > 10 MB komprimieren
          .mt-5
            .small Überschreiben von Dateien und Annotationen
            b-form-radio-group(v-model="overwriteOption")
              b-form-radio(value="skip").p-3 Importiere nur neue Dateien
              b-form-radio(value="overwrite_files_only").p-3 Ersetze bestehende Dateien und behalte Annotationen
              b-form-radio(value="overwrite").p-3 Ersetze bestehende Dateien und überschreibe Annotationen
</template>

<script>
import Vue from 'vue'

export default {
  name: 'SharepointModal',
  props: {
    project: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      currentPath: '', // '' represents root
      breadcrumbs: [''], // Initial breadcrumb is root
      title: "Sharepoint Import",
      directories: [],
      split: false,
      overwriteOption: 'skip',
      files: [],
      selectedFiles: [],
      selectAllFiles: false,
      compressionStrategy: 'none',
      compressionOnlyLargeFiles: false,
    }
  },
  watch: {
    selectedFiles(newVal) {
    
      if (newVal.length === this.files.length) {
        this.selectAllFiles = true
      } else {
        this.selectAllFiles = false
      }
    },
  },
  methods: {
    importFiles(event) {
      const payload = {
        dir_path: this.currentPath,
        should_be_splitted: this.split,
        overwrite_existing_files: this.overwriteOption,
        files: this.selectAllFiles ? 'all' : this.selectedFiles,
        compression_strategy: this.compressionStrategy,
        compression_min_filesize_mb: this.compressionOnlyLargeFiles ? 10 : 0,
      }

      if (this.overwriteOption === 'overwrite') {
        this.$bvModal
          .msgBoxConfirm('Bereits manuell erstellte Annotation können hierbei überschrieben werden!', {
            title: 'Achtung!',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: 'Importieren und Überschreiben',
            cancelTitle: 'Abbrechen',
            hideHeaderClose: false,
            centered: true,
          })
          .then(value => {
            if (value) {
              this.$emit('importFiles', payload)
              this.$refs.sharepointmodal.hide()
            }
          })
          .catch(err => {
            // Handle error
            console.error('Confirmation modal error:', err)
          })

        event.preventDefault()
        event.stopPropagation()
      } else {
        this.$emit('importFiles', payload)
        this.$refs.sharepointmodal.hide()
      }
    },
    open() {
      this.resetState()
      this.fetchDirectories(this.currentPath)
      this.$refs.sharepointmodal.show()
    },
    resetState() {
      this.currentPath = ''
      this.breadcrumbs = ['']
      this.directories = []
      this.files = []
      this.selectedFiles = []
      this.selectAllFiles = false
      this.overwriteOption = 'skip'
      this.split = false
      this.compressionStrategy = (this.project && this.project.compression_strategy) ? this.project.compression_strategy : 'none'
      this.compressionOnlyLargeFiles = !!(this.project && this.project.compression_min_filesize_mb > 0)
    },
    fetchDirectories(path) {
      const endpoint = path === '' 
        ? '/import/sharepoint/directories' 
        : `/import/sharepoint/subdirectories`
      
      this.axios.post(this.base_url + endpoint, {"name": path}).then(response => {
        this.directories = response.data.sort()
      }).catch(error => {
        console.error('Error fetching directories:', error)
        this.directories = []
      })
    },
    fetchFiles(path) {
      this.axios.post(`${this.base_url}/import/sharepoint/files`, {"name": path}).then(response => {
        this.files = response.data.map(file => ({
          name: file.name,
          path: file.serverRelativeUrl,
          folder: file.folder,
          size: file.size,
        })).sort((a, b) => a.name.localeCompare(b.name))
        // Reset selections
        this.selectedFiles = []
        this.selectAllFiles = false
      }).catch(error => {
        console.error('Error fetching files:', error)
        this.files = []
      })
    },
    navigateInto(dir) {
      const newPath = this.currentPath ? `${this.currentPath}/${dir}` : dir
      this.currentPath = newPath
      this.breadcrumbs.push(dir)
      this.fetchDirectories(this.currentPath)
      this.fetchFiles(this.currentPath)
    },
    navigateTo(index) {
      if (index === 0) {
        this.currentPath = ''
        this.breadcrumbs = ['']
      } else {
        this.currentPath = this.breadcrumbs.slice(1, index + 1).join('/')
        this.breadcrumbs = this.breadcrumbs.slice(0, index + 1)
      }
      this.fetchDirectories(this.currentPath)
      this.fetchFiles(this.currentPath)
    },
    toggleSelectAllFiles() {
      if (this.selectAllFiles) {
        // Select all files
        this.selectedFiles = this.files.map(file => file.path + (file.folder ? '/' : ''))
      } else {
        // Deselect all files
        this.selectedFiles = []
      }
    },
    formatFileSize(bytes) {
      if (bytes === null || bytes === undefined || Number.isNaN(Number(bytes))) {
        return 'unbekannt'
      }
      const value = Number(bytes)
      if (value < 1024) return `${value} B`
      if (value < 1024 * 1024) return `${(value / 1024).toFixed(1)} KB`
      if (value < 1024 * 1024 * 1024) return `${(value / (1024 * 1024)).toFixed(2)} MB`
      return `${(value / (1024 * 1024 * 1024)).toFixed(2)} GB`
    }
  },
  mounted() {
    // Ensure Axios is available
    if (!this.axios) {
      this.axios = Vue.prototype.axios
    }
  },
  components: {
    // No additional components needed for this simplified approach
  },
}
</script>

<style scoped>
.breadcrumb {
  cursor: pointer;
}
.breadcrumb-item.active {
  cursor: default;
}
.file-name,
.folder-name {
  display: block;
  width: 100%;
  word-break: break-all;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
